export default {_name:'button.fab',module:'Field',view:'Element/Button/Fab',options:{disabled:true,md:3}}